<template>
  <CreateUpdateProductForm />
</template>

<script setup lang="ts"></script>
